import { Attr, BelongsTo, Model } from 'spraypaint';

import { ApplicationRecord } from './application_record';
import Facility from './facility';

@Model()
export default class Bastion extends ApplicationRecord {
  static jsonapiType = 'bastions';
  @Attr() status: string;
  @Attr() instanceType: string;
  @Attr() instanceId: string;
  @Attr() ipAddress: string;

  @BelongsTo() facility: Facility;
}
